import { mapStyles as styles } from "./map-styles";
import { icon } from "./icon";
import { clusterIcon } from "./cluster-icon";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

const defaultZoomLevel = 4;
const zoomedInLevel = 10;
const minWidth = "350";
let map;

const markerIds = [];

// listed items
const listedItems = $(".locations__list-item");

// Events for basic alert system
const mapAlert = new CustomEvent("no-places");
const mapMove = new CustomEvent("map-move");

// Handel map alert
document.addEventListener("no-places", () => {
    const inactive = document.querySelector(".alert--inactive");
    inactive?.classList.remove("alert--inactive");
});
// remove alert
document.addEventListener("map-move", () => {
    const active = document.querySelector(".alert");
    active?.classList.add("alert--inactive");
});

function new_map($el) {
    // var
    const $markers = $el.find(".marker");

    // vars
    const args = {
        center: new google.maps.LatLng(0, 0),
        mapTypeControl: false,
        panControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        scrollwheel: false,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles
    };

    // create map
    map = new google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each((idx, el) => {
        add_marker($(el), map);
    });

    const markers = markerIds.map((position, i) => {

        return position.marker;
    });

    // bounce animation on hover at .locations__list
    listedItems.on({
        mouseenter: function() {
            const index = $(this).attr("data-index");
            const currentMarker = map.markers[index];
            currentMarker.setAnimation(google.maps.Animation.BOUNCE);
        },
        mouseleave: function() {
            const index = $(this).attr("data-index");
            const currentMarker = map.markers[index];
            currentMarker.setAnimation(null);
        }
    });

    new MarkerClusterer({markers, map, renderer: {
        render: ({ markers, _position: position }) => {

          //here is where you return a Marker
          //and style it w/custom label/icon props
          return new google.maps.Marker({
            position: {
              lat: position.lat(),
              lng: position.lng(),
            },
            icon: {
                url: `data:image/svg+xml;base64,${Buffer.from(clusterIcon).toString("base64")}`,
                scaledSize: new google.maps.Size(50, 50),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(25, 25),
            },
            label: {
                text: String(markers.length),
                color: "rgba(255,255,255,0.9)",
                fontSize: "16px",
            }
          });
        },
      } });

    /**
     * Places API
     **/
    const placesForm = document.querySelector(".search-places-form");
    const placesInput = placesForm?.querySelector("#search-form-places-input");
    let autoComplete;

    // add auto completion list to input
    if (typeof placesInput !== "undefined") {
        autoComplete = new google.maps.places.Autocomplete(placesInput, {
            componentRestrictions: { country: "se" },
            strictbounds: true
        });
    }

    // handle place change
    autoComplete?.addListener("place_changed", () => {
        const place = autoComplete.getPlace();

        // user picked match from list
        if ("geometry" in place && "location" in place.geometry) {
            map.panTo(place.geometry.location);
            map.setZoom(zoomedInLevel);
        } else {
            document.dispatchEvent(mapAlert);
        }
    });

    const geocoder = new google.maps.Geocoder();
    // make prediction on submit
    placesForm?.addEventListener("submit", event => {
        event.preventDefault();
        if (placesInput.value === "") {
            center_map(map);
        } else {
            // set location for submitted value in places form
            // only used if submitted via button click
            // @pacSelectFirst handles enter keydown event
            geocodeAddress(geocoder, map);
        }
    });

    function geocodeAddress(geocoder, resultMap) {
        geocoder.geocode(
            {
                address: placesInput.value,
                componentRestrictions: {
                    country: "se"
                }
            },
            (results, status) => {
                if (status === "OK") {
                    resultMap.setCenter(results[0].geometry.location);
                    resultMap.setZoom(zoomedInLevel);
                } else {
                    document.dispatchEvent(mapAlert);
                }
            }
        );
    }

    // highlight text on click
    placesInput?.addEventListener("click", () => {
        placesInput.select();
        placesInput.focus();
    });

    // filter markers in .locations__list
    google.maps.event.addListener(map, "idle", function() {
        // assign custom event for alert system
        document.dispatchEvent(mapMove);

        const bounds = map.getBounds();
        const $listedMarkers = $(".locations__list-item");

        // bail if no list is present
        if ($listedMarkers.length === 0) {
            return;
        }

        markerIds.forEach(marker => {
            const latlng = new google.maps.LatLng(marker["lat"], marker["lng"]);
            if (bounds.contains(latlng)) {
                document
                    .querySelector(`#item-${marker.id}`)
                    ?.classList.remove("hidden");
            } else {
                document
                    .querySelector(`#item-${marker.id}`)
                    ?.classList.add("hidden");
            }
        });

        const visibleMarkers = document.querySelectorAll(
            ".locations__list-item:not(.hidden)"
        );
        if (visibleMarkers.length === 0) {
            document.dispatchEvent(mapAlert);
        }
    });

    // center map
    center_map(map);

    // select first item of places suggestion list
    (function pacSelectFirst(input) {
        if (typeof input === "undefined") {
            return;
        }
        // store the original event binding function
        var _addEventListener = input.addEventListener
            ? input.addEventListener
            : input.attachEvent;

        function addEventListenerWrapper(type, listener) {
            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
            // and then trigger the original listener.

            if (type == "keydown") {
                var orig_listener = listener;
                listener = function(event) {
                    var suggestion_selected =
                        $(".pac-item-selected").length > 0;
                    if (event.which == 13 && !suggestion_selected) {
                        var simulated_downarrow = $.Event("keydown", {
                            keyCode: 40,
                            which: 40
                        });
                        orig_listener.apply(input, [simulated_downarrow]);
                    }

                    orig_listener.apply(input, [event]);
                };
            }

            // add the modified listener
            _addEventListener.apply(input, [type, listener]);
        }

        if (input.addEventListener)
            input.addEventListener = addEventListenerWrapper;
        else if (input.attachEvent) input.attachEvent = addEventListenerWrapper;
    })(placesInput);
}

let activeInfoWindow;
function add_marker($marker, map) {
    const lat = $marker.attr("data-lat");
    const lng = $marker.attr("data-lng");

    // var
    const latlng = new google.maps.LatLng(lat, lng);

    const marker = new google.maps.Marker({
        position: latlng,
        map,
        icon: {
            url: "data:image/svg+xml;charset=UTF-8;base64," +  Buffer.from(icon).toString("base64"),
            scaledSize: new google.maps.Size(40, 40)
        }
    });

    // save ids and position for later
    markerIds.push({
        id: $marker.data("id"),
        lat,
        lng,
        marker
    });
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
        // create info window

        const infowindow = new google.maps.InfoWindow({
            content: $marker.html(),
            minWidth
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, "click", function() {
            infowindow.open(map, marker);
        });

        marker.addListener("click", function() {
            if (activeInfoWindow) {
                activeInfoWindow.close();
            }
            infowindow.open(map, marker);
            activeInfoWindow = infowindow;
        });
    }

    marker.addListener("click", function() {
        map.setZoom(
            map.getZoom() >= zoomedInLevel ? map.getZoom() : zoomedInLevel
        );
        map.panTo(marker.getPosition());
    });
} // end add_marker

function center_map(map) {
    // vars
    const bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function(i, marker) {
        const latlng = new google.maps.LatLng(
            marker.position.lat(),
            marker.position.lng()
        );
        bounds.extend(latlng);
    });

    // only 1 marker?
    map.setCenter(bounds.getCenter());
    map.setZoom(defaultZoomLevel);
} // end center_map

export { new_map };
